export default __webpack_public_path__ + "navigation-examples-route-init-v1-1200-e76065c3daf6b449e5703bfb82521fa2.webp";